<template>
  <div
    class="gam-gambit-owner"
    :class="{
      list: isList,
      detail: isDetail,
      corner: isCorner,
      menu: isMenu,
      darker: isDarker,
      challenge: isChallenge,
      spark: isSpark,
    }"
  >
    <div class="graphics">
      <div v-if="isClubOwner || isClubOrganizer || isGambitOrganizer || isChallenge" class="gam-owner-icon is-raised">
        <gam-icon :name="GamIconName.OWNER" :is-primary="true" />
      </div>

      <div
        v-if="!isClubOwner && !isClubOrganizer && !isGambitOrganizer && (isFollower || isSpark)"
        class="gam-owner-icon"
      >
        <gam-icon :name="isSpark ? GamIconName.SPARK : GamIconName.HEART" :is-primary="true" />
      </div>
    </div>
    <div v-if="$slots.default" class="ui">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import GamIcon from '@/views/components/GamIcon.vue';
import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';
import type { GamGambitOwnerType } from '@/views/composables/models/components/GamGambit';

defineProps<GamGambitOwnerType>();
</script>

<style scoped lang="scss">
.gam-owner-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  // A star's mass sits below its box, so a centered glyph still reads low.
  &.is-raised {
    transform: translateY(-1px);
  }
}

.gam-gambit-owner {
  display: inline-flex;
  background: var(--color-linear-gradient-10);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
  padding: 0;

  &.darker {
    background: var(--color-linear-gradient-10), var(--color-dark-70);
  }

  &.menu {
    flex-direction: row;
    width: auto;
    height: auto;
    border-radius: 16px;
    padding: 0 var(--spacing-md);
    padding-left: var(--spacing-s);
    gap: var(--spacing-xxs);
  }
}

.graphics {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
